module.exports = __webpack_public_path__ + "static/media/layout2-img.9cdd314d.svg";